import React from "react";
import { Card, CardContent, CardHeader } from "@material-ui/core";
import CRUDParent from "../CRUD/CRUDParent";
import { ParentDto } from "../../api-clients/api";
import { useTranslation } from "react-i18next";

export default function NewStudent() {
  const { t } = useTranslation();
  return (
    <Card>
      <CardHeader title={t("parents.createTitle")} />
      <CardContent>
        <CRUDParent parent={{} as ParentDto} />
      </CardContent>
    </Card>
  );
}